module.exports = __webpack_public_path__ + "img/技术需求库banner.bb3748e8.png";